import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "mydiv",
  class: "window"
}
const _hoisted_2 = { style: {"margin-left":"1%"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_4 = { class: "div-RDM-uploadDownload" }
const _hoisted_5 = {
  id: "tbl-RDM-Confirm",
  class: "tbl-RDM-Confirm-css"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Country:")
], -1 /* HOISTED */)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["value"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { style: {"font-size":"medium","font-weight":"bold","margin-left":"10px"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Station Code:")
], -1 /* HOISTED */)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["value"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { style: {"font-size":"medium","font-weight":"bold","margin-left":"10px"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Target Date:")
], -1 /* HOISTED */)
const _hoisted_17 = ["max", "min"]
const _hoisted_18 = {
  colspan: "2",
  style: {"padding":"0% !important"}
}
const _hoisted_19 = { class: "td-RDM-btnDiv-css" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "lbl-RDM-NoData"
}
const _hoisted_23 = {
  key: 1,
  id: "tbl-RDM-upload",
  class: "tbl-RDM-upload-css"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Latest Upload Date:")
], -1 /* HOISTED */)
const _hoisted_25 = {
  id: "lbl-RDM-latestDate",
  class: "form-control lbl-RDM-latestDate"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"5px"} }, "Select File", -1 /* HOISTED */)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, "File Name:", -1 /* HOISTED */)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  id: "lbl-RDM-uploadedFile",
  class: "form-control lbl-RDM-uploadedFile"
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  class: "td-RDM-err-css",
  colspan: "4"
}
const _hoisted_35 = { class: "div-RDM-error" }
const _hoisted_36 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, [
  /*#__PURE__*/_createTextVNode("Pleasse confirm upload content errors shown in below."),
  /*#__PURE__*/_createElementVNode("br")
], -1 /* HOISTED */)
const _hoisted_39 = { style: {"color":"red"} }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_42 = {
  colspan: "4",
  style: {"text-align":"center","vertical-align":"top"}
}
const _hoisted_43 = ["disabled"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"5px"} }, "Download", -1 /* HOISTED */)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = ["disabled"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"5px"} }, "Upload", -1 /* HOISTED */)
const _hoisted_48 = [
  _hoisted_47
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Alert"], {
        alertMessage: $setup.alertMessage,
        alertState: $setup.alertState
      }, null, 8 /* PROPS */, ["alertMessage", "alertState"])
    ]),
    _createVNode($setup["AdminNavigation"], { menuTile: $setup.pageTitle }, null, 8 /* PROPS */, ["menuTile"]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("tr", null, [
          _hoisted_6,
          ($setup.store.getters.stationCode == '1000')
            ? (_openBlock(), _createElementBlock("td", _hoisted_7, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedCountry) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.countryChange($event))),
                  class: "adjusting-position form-select des-select ddl-RDM"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lstCountry.value, (value, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      class: "adjusting-option",
                      key: index,
                      value: value.countryCode
                    }, _toDisplayString(value.country), 9 /* TEXT, PROPS */, _hoisted_8))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                  [_vModelSelect, $setup.selectedCountry]
                ])
              ]))
            : (_openBlock(), _createElementBlock("td", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString($setup.selectedDetailCountry), 1 /* TEXT */)
              ]))
        ]),
        _createElementVNode("tr", null, [
          _hoisted_11,
          ($setup.store.getters.stationCode == '1000')
            ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.selectedStation) = $event)),
                  class: "adjusting-position form-select des-select ddl-RDM",
                  style: _normalizeStyle({ borderColor: $setup.selectedStation == '' ? 'red' : '#ccc' })
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lstCompany.value, (value, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      class: "adjusting-option",
                      key: index,
                      value: value.stationCode
                    }, _toDisplayString(value.stationCode) + " : " + _toDisplayString(value.companyName), 9 /* TEXT, PROPS */, _hoisted_13))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 4 /* STYLE */), [
                  [_vModelSelect, $setup.selectedStation]
                ])
              ]))
            : (_openBlock(), _createElementBlock("td", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString($setup.selectedDetailCompany), 1 /* TEXT */)
              ]))
        ]),
        _createElementVNode("tr", null, [
          _hoisted_16,
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("input", {
              id: "dt-RDM-YM",
              style: _normalizeStyle({ borderColor: $setup.selectedMonth == '' ? 'red' : '#ccc' }),
              class: "txt-RDM-tblConfirm",
              type: "month",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.selectedMonth) = $event)),
              max: $setup.maxMonth,
              min: $setup.minMonth
            }, null, 12 /* STYLE, PROPS */, _hoisted_17), [
              [_vModelText, $setup.selectedMonth]
            ])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                class: _normalizeClass($setup.isNoRetailAuth || $setup.selectedMonth === '' || $setup.selectedStation === '' ? 'btn-RDM-disabled' : 'btn-RDM'),
                type: "button",
                disabled: $setup.isNoRetailAuth,
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.confirmRMD_Download()))
              }, " Go Download ", 10 /* CLASS, PROPS */, _hoisted_20),
              _createElementVNode("button", {
                class: _normalizeClass($setup.isNoRetailAuth || $setup.selectedMonth === '' || $setup.selectedStation === '' ? 'btn-RDM-disabled' : 'btn-RDM'),
                type: "button",
                disabled: $setup.isNoRetailAuth,
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.confirmRMD_Upload()))
              }, " Go Upload ", 10 /* CLASS, PROPS */, _hoisted_21)
            ])
          ])
        ])
      ]),
      ($setup.isNoUploadedData)
        ? (_openBlock(), _createElementBlock("label", _hoisted_22, _toDisplayString($setup.msgRDM_noData), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (($setup.isConfirmRMD_Upload || $setup.isConfirmRMD_Download) && !$setup.isNoRetailAuth)
        ? (_openBlock(), _createElementBlock("table", _hoisted_23, [
            _createElementVNode("tr", null, [
              _hoisted_24,
              _createElementVNode("td", null, [
                _createElementVNode("label", _hoisted_25, _toDisplayString($setup.lblRDM_latestUploadDate), 1 /* TEXT */)
              ]),
              ($setup.isConfirmRMD_Upload)
                ? (_openBlock(), _createElementBlock("td", _hoisted_26, [
                    _createElementVNode("button", {
                      class: "btn-RDM btn-RDM-Browse",
                      type: "button",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.clickRDM_HiddenUpload()))
                    }, _hoisted_28),
                    _createElementVNode("input", {
                      id: "btnHiddenUpload",
                      hidden: "",
                      type: "file",
                      onChange: $setup.onFileChange
                    }, null, 32 /* HYDRATE_EVENTS */)
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_29, _hoisted_31)),
              _createElementVNode("td", null, [
                _createElementVNode("label", _hoisted_32, _toDisplayString($setup.lblRDM_uploadedFileName), 1 /* TEXT */)
              ])
            ]),
            ($setup.isConfirmRMD_Upload)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                  _createElementVNode("td", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      ($setup.errRDM_HeaderCheck != '')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString($setup.errRDM_HeaderCheck), 1 /* TEXT */))
                        : ($setup.errRDM_ContentCheck.length != 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                              _hoisted_38,
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.errRDM_ContentCheck[0], (item) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: item,
                                  class: "tag"
                                }, [
                                  _createElementVNode("span", _hoisted_39, "Line " + _toDisplayString(item.line_number) + ":", 1 /* TEXT */),
                                  _hoisted_40,
                                  _createElementVNode("span", null, _toDisplayString(item.empty) + _toDisplayString(item.duplicated) + _toDisplayString(item.len) + _toDisplayString(item.lenNotSame) + " " + _toDisplayString(item.alnum) + _toDisplayString(item.input) + _toDisplayString(item.date) + _toDisplayString(item.validDt), 1 /* TEXT */),
                                  _hoisted_41
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]))
                          : _createCommentVNode("v-if", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_42, [
                ($setup.isConfirmRMD_Download)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: _normalizeClass($setup.isNoUploadedData ? 'btn-RDM-disabled' : 'btn-RDM'),
                      disabled: $setup.isNoUploadedData,
                      type: "button",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.clickRDMDownload()))
                    }, _hoisted_45, 10 /* CLASS, PROPS */, _hoisted_43))
                  : _createCommentVNode("v-if", true),
                ($setup.isConfirmRMD_Upload)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn-RDM btn-RDM-Upload",
                      disabled: $setup.isDisableRDM_Upload,
                      type: "button",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.clickRDMUpload()))
                    }, _hoisted_48, 8 /* PROPS */, _hoisted_46))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}